module.exports = __webpack_public_path__ + "img/c_80_1.2a8a9b13.jpg";